import { type Actions, ActionType } from './projects.actions';
import { initialState, projectAdapter, type State } from './projects.state';

export function projectsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_ALL: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_ALL_FAILED: {
            return {
                ...state,
                isPending: false,
                isLoaded: false
            };
        }

        case ActionType.FETCH_ALL_SUCCEEDED: {
            let currentProjectId: string | null = null;
            if (
                action.payload.selectedProjectId &&
                action.payload.projects.map(p => p.projectId).includes(action.payload.selectedProjectId)
            ) {
                currentProjectId = action.payload.selectedProjectId;
            } else {
                const firstProject = action.payload.projects && action.payload.projects.length > 0 ? action.payload.projects[0] : null;
                const firstProjectId = firstProject ? firstProject.projectId : null;
                currentProjectId = firstProjectId;
            }

            return projectAdapter.setAll(action.payload.projects, {
                ...state,
                currentProjectId,
                isPending: false,
                isLoaded: true
            });
        }

        case ActionType.SET_CURRENT_PROJECT_ID: {
            return {
                ...state,
                currentProjectId: action.payload.projectId
            };
        }

        case ActionType.CREATE_PROJECT: {
            return projectAdapter.addOne(action.payload.project, state);
        }

        case ActionType.SET_IS_CHANGING: {
            return {
                ...state,
                isChanging: action.payload.isChanging
            };
        }

        case ActionType.UPDATE_PROJECT: {
            return projectAdapter.updateOne(
                {
                    id: action.payload.projectId,
                    changes: action.payload.project
                },
                state
            );
        }

        case ActionType.RESET: {
            return {
                ...initialState
            };
        }

        default:
            return state;
    }
}
